$(document).ready(function() {
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return "";
  }
  
  $('#seller_change_pass').click(function() {
    var changePasswordPopup = $('.changePassword-popup');
    changePasswordPopup.bPopup({
      positionStyle: 'fixed',
      scrollBar: 'true',
      closeClass: 'modal__close'
    });
  });
  
  //Validating change password form
  function changeSellerPasswordValidation() {
    var NewPassword = $('#seller_new_password').val();
    var NewPasswordConfirm = $('#seller_new_password_confirm').val();
    $(".error_tag").hide();
 
    if(NewPassword.length == 0 && NewPassword == "") {
      $('#seller_new_password').focus();
      $("#seller_new_password_error").fadeIn().html("Please enter new Password");
      return false;
    } else if ((NewPassword.length) <= 5) {
      $('#seller_new_password').focus();
      $("#seller_new_password_error").fadeIn().html("Please enter minimum 6 character password");
      return false;
    }
    if(NewPasswordConfirm.length == 0 && NewPasswordConfirm == "") {
      $('#seller_new_password_confirm').focus();
      $("#seller_new_password_confirm_error").fadeIn().html("Please re enter your new Password");
      return false;
    } else if ((NewPasswordConfirm.length) <= 5) {
      $('#seller_new_password_confirm').focus();
      $("#seller_new_password_confirm_error").fadeIn().html("Please enter minimum 6 character password");
      return false;
    } else if (NewPasswordConfirm != NewPassword) {
      $('#seller_new_password_confirm').focus();
      $("#seller_new_password_confirm_error").fadeIn().html("Your new password does not match");
      return false;
    }
    return true;
  }
  

  $('.seller_change_password_submit').click(function (e){
    e.preventDefault();
    if(changeSellerPasswordValidation()) {
      $(".loding_container").show();
      var changePasswordSubmitBtn = $('#change_password_button');
      changePasswordSubmitBtn.html('Updating...');
      changePasswordSubmitBtn.prop('disabled', true); // disable button

      var emailId = readCookie('seller_email');
      var sessionId = readCookie('session_token');
      var newPassword = $('#seller_new_password').val();

      $.ajax({
        url: "https://test-designers.lovethisstuff.com/login/changeSellerPassword?email=" + emailId + "&seller_session_id=" + sessionId + "&new_password=" + newPassword,
        type: 'GET',
        processData: false,
        async: false,
        success: function(data) {
          $(".loding_container").hide();
          var message = data.message;
          var messageType = data.messageType;
          if (messageType == 'FAILURE' || messageType === "SESSION_EXPIRED") {
            changePasswordSubmitBtn.html('Submit');
            changePasswordSubmitBtn.prop('disabled', false); // disable button
            changePasswordSubmitBtn.attr("disabled", false);
            $('.api_success').hide();
            $('.api_error').hide();
            $('.api_error').html(message).fadeIn();
          } else if (messageType == 'SUCCESS') {
            changePasswordSubmitBtn.html('Saved');
            changePasswordSubmitBtn.prop('disabled', false); // disable button
            changePasswordSubmitBtn.attr("disabled", false);
            $('.api_error').hide();
            $('.api_success').hide();
            $('.api_success').html(message).fadeIn();
            $('#seller_old_password').val('');
            $('#seller_new_password').val('');
            $('#seller_new_password_confirm').val('');
            setTimeout(function() {
              $('.changePassword-popup').bPopup().close();
            }, 2000);
          }
        },
        error: function(data) {
          $(".loding_container").hide();
          changePasswordSubmitBtn.html('Submit');
          changePasswordSubmitBtn.prop('disabled', false); // disable button
          changePasswordSubmitBtn.attr("disabled", false);
          $('.api_success').hide();
          $('.api_error').hide();
          $('#change_password_form .api_error').html('Error please try again later.').fadeIn();
        }
      }); 
    }
  });
});
